<template>
  <div class="d-flex fill-width fill-height">
    <full-text-url-provider
      v-if="hasFullTextPdf"
      v-slot="{ url }"
      :reference-id="reference.id"
    >
      <pdf-document v-if="url" :src="url" />
      <div
        v-else
        class="d-flex justify-center align-center fill-width fill-height"
      >
        <v-progress-circular indeterminate color="primary" />
      </div>
    </full-text-url-provider>
    <upload-full-text-pdf-controller
      v-else
      class="align-center fill-height"
      page-level
      :reference="reference"
    />
  </div>
</template>

<script>
import FullTextUrlProvider from '@/components/FullTextReviewPage/FullTextUrlProvider';
import UploadFullTextPdfController from '@/components/UploadFullTextPdfController/UploadFullTextPdfController';
import PdfDocument from '@/components/Common/PdfDocument';
import { Reference } from '@/models';
export default {
  name: 'FullTextPanel',
  components: {
    FullTextUrlProvider,
    PdfDocument,
    UploadFullTextPdfController,
  },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
  },
  computed: {
    hasUrl() {
      return !!this.url;
    },
    hasFullTextPdf() {
      return !!this.reference.fullTextPdfUri;
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-width {
  width: 100%;
}
</style>
